module.exports = __webpack_public_path__ + "img/bg-rockets-mobile.a41139a0.png";